import { render, staticRenderFns } from "./InboundScanModal.vue?vue&type=template&id=83280b72"
import script from "./InboundScanModal.vue?vue&type=script&lang=js"
export * from "./InboundScanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports